import { render, staticRenderFns } from "./setPass.vue?vue&type=template&id=76404a6e&scoped=true"
import script from "./setPass.vue?vue&type=script&lang=js"
export * from "./setPass.vue?vue&type=script&lang=js"
import style0 from "./setPass.vue?vue&type=style&index=0&id=76404a6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76404a6e",
  null
  
)

export default component.exports